var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOosInformationBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "16px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -125 -83 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.2 7.2  L 7.2 12  L 8.8 12  L 8.8 7.2  L 7.2 7.2  Z M 16 8  C 16 3.580000000000001  12.419999999999998 0  8 0  C 3.5799999999999996 0  0 3.5799999999999996  0 8  C 0 12.419999999999998  3.5799999999999996 16  8 16  C 12.419999999999998 16  16 12.419999999999998  16 8  Z M 14.4 8  C 14.4 11.528  11.528 14.4  8 14.4  C 4.4719999999999995 14.4  1.6 11.528  1.6 8  C 1.6 4.4719999999999995  4.4719999999999995 1.6  8 1.6  C 11.528 1.6  14.4 4.4719999999999995  14.4 8  Z M 7.2 4  L 7.2 5.6  L 8.8 5.6  L 8.8 4  L 7.2 4  Z ",
    fillRule: "nonzero",
    fill: "red",
    stroke: "none",
    transform: "matrix(1 0 0 1 125 83 )"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOosInformationBubble);
export default __webpack_public_path__ + "static/media/oos_information_bubble.6f109e9428bd88efc95125f7da505165.svg";
export { ForwardRef as ReactComponent };